import type { Props } from "~/components/floatingButtons/FloatingButtons"
import { lazy, Suspense } from "react"
import { useLoadedOnMouseMove } from "~/sdk/useUI"

const Buttons = lazy(() => import('~/components/floatingButtons/FloatingButtons'))

export default function FloatingButtons(props: Props) {
    const loaded = useLoadedOnMouseMove()

    return <Suspense fallback={null}>{loaded && <Buttons {...props} />}</Suspense>
}
